export const defaultWithEmptyStr = (str) => (str ? str : '');
